<template>
  <div class="inputer-number" :class="{'not-valid': !valid}">
    <input
      type="number"
      :value="value"
      @input="change"
      :placeholder="name"
      :disabled="disabled"
      :min="min"
      :max="max"
      :step="step"
      :id="id"
    />
    <div v-if="changed" class="changed" title="Neuložená změna">
      <i class="fa fa-wrench" />
    </div>
  </div>
</template>

<script>
export default {
  name: "inputerNumber",
  props: {
    id: { default: null },
    name: { default: "" },
    paths: {},
    disabled: { default: false },
    min: { default: null },
    max: { default: null },
    step: { default: 1 }
  },
  computed: {
    value() {
      return this.$store.getters.getAt(this.paths);
    },
    changed() {
      return this.$store.getters.isChangedAt(this.paths);
    },
    valid() {
      return this.$store.getters.isValidAt(this.paths);
    }
  },
  methods: {
    change(event) {
      let value = parseFloat(event.target.value);
      if (isNaN(value))
        value = 0;
      if (this.max != null && value > this.max)
        value = this.max;
      if (this.min != null && value < this.min)
        value = this.min;

      event.target.value = value;

      this.$store.commit("update", {
        paths: this.paths,
        value: value
      });
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_components

.inputer-number
  @include inputer()
</style>
